import AssetDescription from './component'
export default AssetDescription
